// src/sim/placement.ts -- pure, no DOM
import type { Terrain } from './terrain';
import type { Rng } from './rng';

/**
 * Place N tanks evenly across terrain using zone-based spacing with jitter.
 * Each tank is placed 4px above the terrain surface at its x position.
 */
export function placeTanks(
  count: number,
  terrain: Terrain,
  rng: Rng,
): { x: number; y: number }[] {
  const margin = 60;
  const usable = terrain.width - 2 * margin;
  const spacing = usable / count;
  const positions: { x: number; y: number }[] = [];

  for (let i = 0; i < count; i++) {
    const zoneCenter = margin + spacing * (i + 0.5);
    const jitter = (rng() - 0.5) * spacing * 0.6;
    let x = Math.round(zoneCenter + jitter);
    x = Math.max(margin, Math.min(terrain.width - margin, x));

    // Find terrain surface: scan downward for first solid pixel
    let y = 0;
    while (y < terrain.height && !terrain.isSolid(x, y)) y++;
    positions.push({ x, y: y - 4 });
  }
  return positions;
}
